import { Button } from '~/shared/components/buttons/Button';
import { ChevronRight } from 'lucide-react';
import { useFormRegistry } from '~/shared/forms/FormRegistryContext';
import { useGoalsAndInterventionsWizard } from '../GoalsAndInterventionsWizardContext';

export function SelectGoalFooter() {
	const { isValidByForm, getFormValues } = useFormRegistry();
	const { dispatch } = useGoalsAndInterventionsWizard();
	const nextClicked = () => {
		const formValues = getFormValues('custom');
		dispatch({ type: 'CUSTOM_GOAL_DETAILS_ENTERED', formValues: formValues });
	};
	return <Button onClick={nextClicked} Icon={ChevronRight} label="Next" isDisabled={!isValidByForm['custom']} />;
}
